module.exports = __webpack_public_path__ + "media/images/sale_crm/tickets-7d9796cbbaa79d38970e65acad685ea8.svg";